import { GroupPluginItem } from "./GroupPluginItem";

export default GroupPluginItem;
